export default "__VITE_ASSET__lgZUwatE__"